export default __webpack_public_path__ + "static/media/finance-guide-pcp.6ae8b12e.svg";